import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {MixAndMatchData} from "./mix-and-match.data";
import {Injectable, Injector} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {MembershipTypeReferenceData} from "../../customers/membership-type/membership-type.data";
import {MembershipTypeSearchModel} from "../../customers/membership-type/membership-type-search.model";

@Injectable()
export class MixAndMatchEntityModel extends EntityModel<MixAndMatchData> {

    constructor(injector: Injector) {
        super(injector, MixAndMatchData);
    }

    protected override onAfterLoadEntity(mixAndMatch: MixAndMatchData): void {
        const translateService: TranslateService = this.injector.get(TranslateService, null)
        if (mixAndMatch.memberLoyalty.includeGuests) {
            const guest: MembershipTypeReferenceData = EntityData.create(MembershipTypeReferenceData);
            guest.name = translateService.instant("wbo.membership-type.option.guest");
            guest.membershipTypeId = MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE;
            mixAndMatch.memberLoyalty.mixAndMatchMemberTypes.unshift(guest);
        }
    }

    protected override onBeforeSaveEntity(mixAndMatch: MixAndMatchData): void {
        mixAndMatch.memberLoyalty.includeGuests = !!mixAndMatch.memberLoyalty.mixAndMatchMemberTypes.find((member: MembershipTypeReferenceData) => member.membershipTypeId === MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
        mixAndMatch.memberLoyalty.mixAndMatchMemberTypes = mixAndMatch.memberLoyalty.mixAndMatchMemberTypes.filter((member: MembershipTypeReferenceData) => member.membershipTypeId !== MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
    }
}
